import { motion } from "framer-motion";

function CTA({ openModal }) {
  return (
    <section className="cta">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2>Ready to start your digital transformation?</h2>
        <p>Let's discuss how Cabptoid can accelerate your business growth today.</p>
        <motion.button 
          className="btn-primary"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={openModal}
        >
          Book a Free Consultation
        </motion.button>
      </motion.div>
    </section>
  );
}

export default CTA;